/**
 * File quiz-banner.js
 * Handles displaying the quiz banner itself
 * Tracks cta clicks
 */

const quizBanners = document.querySelectorAll(".quiz-sticky-banner") ?? [];

quizBanners.forEach(banner => {
    const quizID = banner.getAttribute('data-quiz-id');
    const quizCookieName = `quiz#${quizID}`;

    if (document.cookie.indexOf(quizCookieName) !== -1) {
        closeBanner(banner, false);
        return;
    }

    const dismissButton = banner.querySelector('.dismiss');

    if (dismissButton != null) {
        dismissButton.addEventListener('click', (e) => {
            e.preventDefault();
            trackQuizInteraction(quizID, 'banner_dismissed');
            closeBanner(banner);
        });
    }
});
